import type { ReglaMeta } from '../types/metas.types';

/**
 * META AL BODEGUERO (23-oct-2026, decisión del usuario): «el bodeguero debería
 * poder cobrar cuando no tienen vendedores […] opcional colocarle meta al
 * bodeguero pero con la advertencia al final "se le está colocando meta al
 * bodeguero"».
 *
 * La regla del puesto NO cambia (`no_lleva`): sin meta no queda pendiente, la
 * meta no se copia a la semana siguiente ni se le reparte. Sólo se abre la
 * casilla y se avisa. La misma regla que `esMetaABodeguero` de la API
 * (`domain/validar-captura.ts`), que manda la advertencia META_A_BODEGUERO y la
 * lista `revision.bodeguerosConMeta` (fuera de `alertas`: no saca del lote).
 *
 * El cajero sigue sin poder llevar meta.
 */
export interface FilaBodega {
  reglaMeta?: ReglaMeta | null;
  esBodega?: boolean;
  metaMonto: number | null | undefined;
}

/** Un puesto de bodega cuya regla no le pide meta: la casilla se abre, opcional. */
export const metaOpcionalDeBodega = (f: Pick<FilaBodega, 'reglaMeta' | 'esBodega'>): boolean =>
  !!f.esBodega && (f.reglaMeta ?? 'obligatoria') !== 'obligatoria';

/** ¿A esta fila «se le está colocando meta al bodeguero»? Con meta en pesos (mayor que cero). */
export const esMetaABodeguero = (f: FilaBodega): boolean =>
  metaOpcionalDeBodega(f) &&
  f.metaMonto !== null &&
  f.metaMonto !== undefined &&
  Number.isFinite(f.metaMonto) &&
  f.metaMonto > 0;

/** El código de la advertencia de la API: la pantalla la pinta en vivo, no la repite. */
export const CODIGO_META_A_BODEGUERO = 'META_A_BODEGUERO';

/** Lo que pidió el usuario, tal cual, con mayúscula inicial. */
export const TEXTO_META_A_BODEGUERO = 'Se le está colocando meta al bodeguero';
